import { Schema, type } from "@colyseus/schema"

export class GameMode extends Schema {
  @type("boolean") transferable!: boolean

  @type("boolean") all!: boolean

  @type("boolean") fair!: boolean

  @type("boolean") draw!: boolean

  constructor(
    transferable?: boolean,
    all?: boolean,
    fair?: boolean,
    draw?: boolean
  ) {
    super()

    this.transferable = transferable === undefined ? false : transferable
    this.all = all === undefined ? false : all
    this.fair = fair === undefined ? true : fair
    this.draw = draw === undefined ? false : draw
  }
}
